export const Faq = {
    fromServer: (item) => {
        return {
            argument: item.argument,
            text: item.text,
            title: item.title,
            id: item.id
        }
    }
}